export const getFlagEmoji = (countryCode: string): string =>
  countryCode.toUpperCase().replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt(0)))
